import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "babySeat"
const BabySeatIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.17 21H19.5a1 1 0 0 0 0-2l-10.669.004L5.983 3.816a1.001 1.001 0 0 0-1.966.368L7.17 21Zm2.344-3.835-1.5-9a1 1 0 0 1 .743-1.135c1.623-.406 2.75-.244 3.413.654.47.634.535 1.177.537 2.67.001.662.01.961.046 1.317.1.96.395 1.6 1.03 2.075.528.397.817.344 1.675-.206.98-.628 1.25-.767 1.884-.779.786-.016 1.448.416 1.99 1.23.171.257.214.578.117.871l-.819 2.454a.998.998 0 0 1-.948.684H10.5a1 1 0 0 1-.986-.835Z"
          />
        </svg>
      }
    </span>
  )
}
export default BabySeatIcon
